import React, { useState } from "react"
import { Col, Row } from "antd"
import { Check } from "react-feather"

// ui
import { Text } from "ui/Typography"
import { useDispatch, useSelector } from "react-redux"
import { disconnectOAuthProvider } from "store/user"
import { notification } from "ui/Notification"
import PropTypes from "prop-types"
import DisconnectConfirmation from "./Modals/DisconnectConfirmation"
import { toaster } from "components/common/Toast"
import { useTranslation } from "react-i18next"

export const LinkedAccount = ({ icon, account, provider, connected = false, connectOAuth }) => {
  const dispatch = useDispatch()
  const [isDisconnectModalOpen, setIsDisconnectModalOpen] = useState(false)
  const { is_password, connected_oauth_providers } = useSelector((state) => state.user)
  const { t } = useTranslation()

  const openDisconnectModal = () => setIsDisconnectModalOpen(true)

  const startConnect = () => {
    connectOAuth()
  }

  const handleDisconnect = () => {
    if (is_password || connected_oauth_providers?.length > 1) {
      dispatch(disconnectOAuthProvider(provider)).then((res) => {
        notification.success({
          message: res?.message
        })
      })
      setIsDisconnectModalOpen(false)
    } else {
      toaster.error(t("auth.at_least_one_login_method"))
    }
  }

  return (
    <>
      <Row
        gutter={[12, 12]}
        wrap={false}
        align="middle"
        className={"px-m py-s bordered rounded-s clickable"}
        onClick={connected ? openDisconnectModal : startConnect}
      >
        <Col span={6}>
          <img src={icon} width={40} alt={account} className="object-contain h-auto" />
        </Col>
        <Col span={16} className="flex-column">
          <Text>{account}</Text>
          <Text fw={500} className="text-color-primary">
            {connected ? "Disconnect" : "Connect"}
          </Text>
        </Col>
        {connected && (
          <Col span={2}>
            <Check size={16} className="text-color-primary flex-none" />
          </Col>
        )}
      </Row>
      {isDisconnectModalOpen && (
        <DisconnectConfirmation
          onOpen={isDisconnectModalOpen}
          onClose={() => setIsDisconnectModalOpen(false)}
          handleDisconnect={handleDisconnect}
          provider={account}
        />
      )}
    </>
  )
}

LinkedAccount.propTypes = {
  icon: PropTypes.string.isRequired,
  account: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
  connected: PropTypes.bool,
  connectOAuth: PropTypes.func.isRequired
}
